import React, {
    createContext,
    useContext,
    useState,
    useEffect,
} from "react"

import api from "../api"

export const MenuContext = createContext(null)

export const MenuProvider = ({ children }) => {

    const [realtimeNotification, setRealtimeNotification] = useState(null)
    const [activeChat, setActiveChat] = useState({})
    const [configurableUrls, setConfigurableUrls] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get("/api/configurable_urls/")
                if (res.status === 200) {
                    setConfigurableUrls(
                        res.data.reduce((acc, item) => {
                            acc[item.name] = item.url
                            return acc
                        }, {})
                    )
                }
            } catch (error) {
                console.error(error)
            }
        }

        fetchData()
    }, [])

    return (
        <MenuContext.Provider
            value={{
                realtimeNotification,
                setRealtimeNotification,
                activeChat,
                setActiveChat,
                configurableUrls,
            }}
        >
            {children}
        </MenuContext.Provider>
    )
}


export const useMenu = () => {
    const context = useContext(MenuContext)

    if (!context) {
        throw new Error(
            "useMenu must be used inside MenuProvider"
        )
    }

    return context
}
